export const DEV = 'dev'
export const STABLE = 'stable'
export const PROD = 'app'
export const ENV = STABLE

export const CBM_APP_VERSION = '113'

export const ENV_SUBDOMAIN = ENV === PROD ? '' : `${ENV}.`
export const API_BASE_URL = `https://${ENV_SUBDOMAIN}api.comebackmobility.com/api/v1`